import { ArrowRightIcon, Loader2Icon } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Button } from 'slab'
import { usePatchResourceAccessTokensIdRedeem as useRedeemResourceAccessToken } from 'utils/web_api'
import { useWindowLocation } from 'utils/windowLocation'

import LoadingSpinnerCentered from './reusable/LoadingSpinnerCentered'

const RESOURCE_TYPE_DICT = {
  'Quoting::Quote': 'quote',
}

const VerifyResourceAccessToken = (
  { tokenId, onSuccessUrlPath, onNoAccessUrlPath, redeemTokenMethod, resourceType, invitedByEmail }:
  { tokenId: string, onSuccessUrlPath: string, onNoAccessUrlPath: string, redeemTokenMethod: 'page_view' | 'click', resourceType: 'Quoting::Quote', invitedByEmail: string }
) => {
  const { replace } = useWindowLocation()

  const [isNavigating, setIsNavigating] = useState(false)
  const redeemTokenMutation = useRedeemResourceAccessToken()

  const redeemToken = () => {
    redeemTokenMutation.mutate({ id: tokenId }, {
      onSuccess: ({ redeemed, cannot_redeem_reason: reason }) => {
        setIsNavigating(true)
        if (redeemed) {
          replace(onSuccessUrlPath)
        } else {
          const url = new URL(onNoAccessUrlPath, window.location.origin)
          url.searchParams.set('reason', reason ?? 'unknown')
          replace(url.toString())
        }
      },
      onError: (error) => {
        setIsNavigating(true)
        console.error(error)
        const url = new URL(onNoAccessUrlPath, window.location.origin)
        url.searchParams.set('reason', 'unhandled_error')
        replace(url.toString())
      },
    })
  }

  useEffect(() => {
    if (redeemTokenMethod === 'page_view') {
      redeemToken()
    }
  }, [])

  return (
    <div className='h-screen w-screen flex items-center justify-center bg-white'>
      {redeemTokenMethod === 'page_view' && (
        <LoadingSpinnerCentered />
      )}
      {redeemTokenMethod === 'click' && (
        <div className='text-center'>
          <h1 className='heading-md text-gray-800'>You've been invited to view a {RESOURCE_TYPE_DICT[resourceType]} by {invitedByEmail}</h1>
          <h3 className='heading-xs text-gray-500 mt-2 mb-8'>Accepting your invite will grant you access to this quote on this device and browser only.</h3>
          <Button onClick={redeemToken} variant='primary' disabled={redeemTokenMutation.isPending || isNavigating} size='large'>
            <div className='flex items-center gap-2'>
              I understand, let's go <ArrowRightIcon className='w-4 h-4' /> {(redeemTokenMutation.isPending || isNavigating) && <Loader2Icon className='w-4 h-4 animate-spin' />}
            </div>
          </Button>
        </div>
      )}
    </div>
  )
}

export default VerifyResourceAccessToken
